import { NgModule } from '@angular/core';
import { WizLayoutModule, WizModule } from '@wizeoo/akm-component-lib';
import { WizNgxCharts } from './components/wiz-ngx-charts/wiz-ngx-charts.component'
import { BarHorizontal2DComponent } from './components/ngx-charts/bar-chart/bar-horizontal-2d.component';
import { BarHorizontalStackedComponent } from './components/ngx-charts/bar-chart/bar-horizontal-stacked.component';
import { BarHorizontalComponent } from './components/ngx-charts/bar-chart/bar-horizontal.component';
import { BarLabelComponent } from './components/ngx-charts/bar-chart/bar-label.component';
import { BarVertical2DComponent } from './components/ngx-charts/bar-chart/bar-vertical-2d.component';
import { BarVerticalStackedComponent } from './components/ngx-charts/bar-chart/bar-vertical-stacked.component';
import { BarVerticalComponent } from './components/ngx-charts/bar-chart/bar-vertical.component';
import { BarComponent } from './components/ngx-charts/bar-chart/bar.component';
import { SeriesHorizontal } from './components/ngx-charts/bar-chart/series-horizontal.component';
import { SeriesVerticalComponent } from './components/ngx-charts/bar-chart/series-vertical.component';
import { AreaComponent } from './components/ngx-charts/common/area.component';
import { AxisLabelComponent } from './components/ngx-charts/common/axes/axis-label.component';
import { XAxisTicksComponent } from './components/ngx-charts/common/axes/x-axis-ticks.component';
import { XAxisComponent } from './components/ngx-charts/common/axes/x-axis.component';
import { YAxisTicksComponent } from './components/ngx-charts/common/axes/y-axis-ticks.component';
import { YAxisComponent } from './components/ngx-charts/common/axes/y-axis.component';
import { BaseChartComponent } from './components/ngx-charts/common/base-chart.component';
import { ChartComponent } from './components/ngx-charts/common/charts/chart.component';
import { CircleSeriesComponent } from './components/ngx-charts/common/circle-series.component';
import { CircleComponent } from './components/ngx-charts/common/circle.component';
import { CountUpDirective } from './components/ngx-charts/common/count/count.directive';
import { GridPanelSeriesComponent } from './components/ngx-charts/common/grid-panel-series.component';
import { GridPanelComponent } from './components/ngx-charts/common/grid-panel.component';
import { AdvancedLegendComponent } from './components/ngx-charts/common/legend/advanced-legend.component';
import { LegendEntryComponent } from './components/ngx-charts/common/legend/legend-entry.component';
import { LegendComponent } from './components/ngx-charts/common/legend/legend.component';
import { ScaleLegendComponent } from './components/ngx-charts/common/legend/scale-legend.component';
import { SvgLinearGradientComponent } from './components/ngx-charts/common/svg-linear-gradient.component';
import { SvgRadialGradientComponent } from './components/ngx-charts/common/svg-radial-gradient.component';
import { Timeline } from './components/ngx-charts/common/timeline/timeline.component';
import { TooltipArea } from './components/ngx-charts/common/tooltip-area.component';
import { TooltipContentComponent } from './components/ngx-charts/common/tooltip/tooltip.component';
import { TooltipDirective } from './components/ngx-charts/common/tooltip/tooltip.directive';
import { GaugeArcComponent } from './components/ngx-charts/gauge/gauge-arc.component';
import { GaugeAxisComponent } from './components/ngx-charts/gauge/gauge-axis.component';
import { GaugeComponent } from './components/ngx-charts/gauge/gauge.component';
import { LineChartComponent } from './components/ngx-charts/line-chart/line-chart.component';
import { LineSeriesComponent } from './components/ngx-charts/line-chart/line-series.component';
import { LineComponent } from './components/ngx-charts/line-chart/line.component';
import { CardSeriesComponent } from './components/ngx-charts/number-card/card-series.component';
import { CardComponent } from './components/ngx-charts/number-card/card.component';
import { NumberCardComponent } from './components/ngx-charts/number-card/number-card.component';
import { PieArcComponent } from './components/ngx-charts/pie-chart/pie-arc.component';
import { PieChartComponent } from './components/ngx-charts/pie-chart/pie-chart.component';
import { PieLabelComponent } from './components/ngx-charts/pie-chart/pie-label.component';
import { PieSeriesComponent } from './components/ngx-charts/pie-chart/pie-series.component';
import { TreeMapCellSeriesComponent } from './components/ngx-charts/tree-map/tree-map-cell-series.component';
import { TreeMapCellComponent } from './components/ngx-charts/tree-map/tree-map-cell.component';
import { TreeMapComponent } from './components/ngx-charts/tree-map/tree-map.component';
import { MultiDisplay } from './components/multi-display/multi-display.component';
import { ConnectReturnRenderer } from './manager/core/connectrenderers/connect-return-renderer';
import { ConnectItemRenderer } from './manager/core/connectrenderers/connect-item-renderer';
import { AgActionDeleteRenderer } from './framework/components/grid/renderers/ag-action-delete.renderer';
import { AgLabelValidityRenderer } from './framework/components/grid/renderers/ag-label-validity.renderer';
import { WidgetRenderer } from './framework/components/widget/widget.renderer';
import { BaseTileRenderer } from './framework/components/tile/renderers/basetile.renderer';
import { LoadinPop } from './views/main/loading/loading.pop';
import { CmdErrorPop } from './command/cmderror.pop';
import { Pivot } from './components/widgets/pivot/pivot.component';
import { PivotCellEditor } from './components/widgets/pivot/renderers/cells/pivot-cell.editor';
import { OtherCellEditor } from './components/widgets/pivot/renderers/cells/other-cell.editor';

import { PivotBasePop } from './components/widgets/pivot/renderers/settings/pivot-base.pop';
import { PivotExtendedPop } from './components/widgets/pivot/renderers/settings/pivot-extended.pop';
import { PivotGroupEditItemRenderer } from './components/widgets/pivot/renderers/settings/pivot-groupedit-item.renderer';
import { PivotEditItemRenderer } from './components/widgets/pivot/renderers/settings/pivot-edit-item.renderer';
import { PivotDeleteFieldRenderer } from './components/widgets/pivot/renderers/cells/pivot-delete-field.renderer';
import { PivotFilterExtendedRenderer } from './components/widgets/pivot/renderers/filters/pivot-filter-extended.renderer';
import { PivotCellEditPop } from './components/widgets/pivot/renderers/cells/pivot-cell-edit.pop';
import { PivotCellFilterkeyEditPop } from './components/widgets/pivot/renderers/cells/pivot-cell-filterkey-edit.pop';
import { PivotCellCrosskeyEditPop } from './components/widgets/pivot/renderers/cells/pivot-cell-crosskey-edit.pop';

import { PivotCellWorkflowEditPop } from './components/widgets/pivot/renderers/cells/pivot-cell-workflow-edit.pop';
import { WorkcomMessageRenderer } from './components/widgets/pivot/renderers/cells/workcom-message.renderer';
import { WorkcomMessagePop } from './components/widgets/pivot/renderers/cells/workcom-message.pop';


import { PivotCellListEditPop } from './components/widgets/pivot/renderers/cells/pivot-cell-list-edit.pop';
import { PivotCellThresholdEditPop } from './components/widgets/pivot/renderers/cells/pivot-cell-threshold-edit.pop';

import { PivotCellDeletePop } from './components/widgets/pivot/renderers/cells/pivot-cell-delete.pop';
import { PivotCellMassDeletePop } from './components/widgets/pivot/renderers/cells/pivot-cell-mass-delete.pop';
import { PivotFilterExtendedPop } from './components/widgets/pivot/renderers/filters/pivot-filter-extended.pop';
import { PivotScenExtendedPop } from './components/widgets/pivot/renderers/filters/pivot-scen-extended.pop';
import { PivotHeaderRenderer } from './components/widgets/pivot/renderers/header/pivot-header.renderer';
import { PivotHeaderGroupRenderer } from './components/widgets/pivot/renderers/header/pivot-headergroup.renderer';
import { HeaderGroupEditPop } from './components/widgets/pivot/renderers/header/header-groupedit.pop';
import { HeaderEditExtPop } from './components/widgets/pivot/renderers/header/header-editext.pop';
import { HeaderEditStyleSubPop } from './components/widgets/pivot/renderers/header/header-edit-style.sub.pop';
import { PivotIncExcRenderer } from './components/widgets/pivot/renderers/cells/pivot-incexc.renderer';

import { ConnectButton } from './manager/core/connectrenderers/connect-button';
import { ConnectIconRenderer } from './manager/core/connectrenderers/connect-icon.renderer';
import { ConnectSmallRenderer } from './manager/core/connectrenderers/connect-small.renderer';
import { ExcelErrorPop } from './manager/export/excel-error.pop';
import { ColorPickerPop } from './components/colorpicker/color-picker.pop';
import { NextStepPivot } from './components/tools/next-step-pivot.component';
import { ToolPivot } from './components/tools/tool-pivot.component';
import { ConditionRenderer } from './components/widgets/pivot/renderers/header/condition.renderer';
import { AddFunctionPop } from './components/measures/pops/add-function.pop';
import { AddMeasurePop } from './components/measures/pops/add-measure.pop';
import { AddFunctionRenderer } from './components/measures/pops/compos/add-function.renderer';
import { AddMeasureRenderer } from './components/measures/pops/compos/add-measure.renderer';
import { FormulaEditorInput } from './components/measures/pops/compos/formula-editor.input';
import { FormulaEditorPop } from './components/measures/pops/formula-editor.pop';
import { MeasureKindRenderer } from './components/measures/renderers/measure-kind.renderer';
import { FilterMassPop } from './components/widgets/pivot/renderers/header/mass/filter-mass.pop';
import { FilterMassRenderer } from './components/widgets/pivot/renderers/header/mass/filter-mass.renderer';
import { FreedataHeaderEditPop } from './components/widgets/freedatas/pops/freedata-header-edit.pop';
import { ScenSpotRenderer } from './components/widgets/pivot/renderers/filters/scen-spot.renderer';
import { ColorPickerModule } from 'ngx-color-picker';

import { ChartWidget } from './components/widgets/chart/chart.widget';
import { ChartEditItemRenderer } from './components/widgets/chart/renderer/chart-edit-item.renderer';
import { ChartSettingsPop } from './components/widgets/chart/pop/chart-settings.pop';
import { ChartParamRenderer } from './components/widgets/chart/renderer/chart-param.renderer';
import { ChartItemSettingPop } from './components/widgets/chart/pop/chartitem-setting.pop';
import { ListExtendedPop } from './components/widgets/list/list-extended.pop';
import { ListWidgetItemRenderer } from './components/widgets/list/list-widget-item.renderer';
import { ListWidget } from './components/widgets/list/list.widget';

import { FreedataGridWidget } from './components/widgets/freedatas/freedatagrid.widget';
import { FreedataFormSettingsPop } from './components/widgets/freedatas/pops/freedata-form-settings.pop';
import { FreedataGridDeletePop } from './components/widgets/freedatas/pops/freedata-grid-delete.pop';
import { FreedataGridsterItem } from './components/widgets/freedatas/pops/freedata-gridster-item.component';
import { FreedataGridsterComponent } from './components/widgets/freedatas/pops/freedata-gridster.component';
import { FreedataSettingsPop } from './components/widgets/freedatas/pops/freedata-settings.pop';
import { FreedataWidgetDataPop } from './components/widgets/freedatas/pops/freedata-widget-data.pop';
import { FreedataEditItemRenderer } from './components/widgets/freedatas/pops/freedata-edit-item.renderer';
import { VisionKeyRenderer } from './components/widgets/base/vision-key.renderer';

import { BaselineGridsterItem } from './components/widgets/form/baseline-gridster-item.component';
import { BaselineGridsterComponent } from './components/widgets/form/baseline-gridster.component';
import { FormDropExtendedChronocodePop } from './components/widgets/form/drops/form-drop-extended-chronocode.pop';
import { FormDropExtendedFreedataPop } from './components/widgets/form/drops/form-drop-extended-freedata.pop';
import { FormDropExtendedRenderer } from './components/widgets/form/drops/form-drop-extended.renderer';
import { FormExtendedPop } from './components/widgets/form/form-extended.pop';
import { FormFieldRenderer } from './components/widgets/form/form-field.renderer';
import { FormWidget } from './components/widgets/form/form.widget';
import { BaselineFieldSettingsPop } from './components/widgets/form/pops/baseline-field-settings.pop';
import { BaselineFormChoosePop } from './components/widgets/form/pops/baseline-form-choose.pop';
import { ArgsRenderer } from './components/widgets/freedatas/renderers/args.renderer';
import { ImageSourcePop } from './components/widgets/freedatas/renderers/imagesource.pop';
import { FreedataFieldSettingsPop } from './components/widgets/freedataform/pops/freedata-field-settings.pop';
import { GridsterModule } from 'angular-gridster2';
import { GlobalFilterSettingPop } from './components/widgets/globalfilter/global-filter-settings.pop';
import { GlobalFilter } from './components/widgets/globalfilter/global-filter.component';
import { CalendarAddPop } from './components/widgets/calendar/calendar-add.pop';
import { CalendarEventRenderer } from './components/widgets/calendar/calendar-event.renderer';
import { CalendarWidget } from './components/widgets/calendar/calendar.widget';
import { CalendarExtendedPop } from './components/widgets/calendar/pop/calendar-extended.pop';
import { FullCalendarModule } from '@fullcalendar/angular';
import { TimelineFieldRenderer } from './components/widgets/timeline/filters/timeline-field.renderer';
import { TimelineSettingsPop } from './components/widgets/timeline/pops/timeline-settings.pop';
import { TimelineEditItemRenderer } from './components/widgets/timeline/renderers/timeline-edit-item.renderer';
import { TimelineEventRenderer } from './components/widgets/timeline/timeline-event.renderer';
import { TimelineWidget } from './components/widgets/timeline/timeline.widget';
import { FreedataTileWidget } from './components/widgets/tiles/freedata-tile.widget';
import { FreedataTileGridsterItem } from './components/widgets/tiles/gridster/freedata-tile-gridster-item.component';
import { FreedataTileGridsterComponent } from './components/widgets/tiles/gridster/freedata-tile-gridster.component';
import { SmallArgsRenderer } from './components/widgets/tiles/gridster/smallargs.renderer';
import { SmallFormFieldRenderer } from './components/widgets/tiles/gridster/smallformfield.renderer';
import { TileGridsterItem } from './components/widgets/tiles/gridster/tile-gridster-item.component';
import { TileGridsterComponent } from './components/widgets/tiles/gridster/tile-gridster.component';
import { FreedataTileRenderer } from './components/widgets/tiles/renderers/freedata-tile.renderer';
import { TileRenderer } from './components/widgets/tiles/renderers/tile.renderer';
import { FreedataTileSettingsPop } from './components/widgets/tiles/settings/freedata-tile-settings.pop';
import { FreedataTileFilterPop } from './components/widgets/tiles/settings/freedata-tile-filter.pop';
import { TileSettingsPop } from './components/widgets/tiles/settings/tile-settings.pop';
import { TileWidget } from './components/widgets/tiles/tile.widget';
import { FreedataCalendarAddPop } from './components/widgets/freedatacalendar/freedata-calendar-add.pop';
import { FreedataCalendarWidget } from './components/widgets/freedatacalendar/freedata-calendar.widget';
import { FreedataCalendarSettingsPop } from './components/widgets/freedatacalendar/pops/freedata-calendar-settings.pop';
import { FreedataTimelineFilterExtendedPop } from './components/widgets/freedatatimeline/filters/freedata-timeline-filter-extended.pop';
import { FreedataTimelineFilterExtendedRenderer } from './components/widgets/freedatatimeline/filters/freedata-timeline-filter-extended.renderer';
import { FreedataTimelineEventRenderer } from './components/widgets/freedatatimeline/freedata-timeline-event.renderer';
import { FreedataTimelineWidget } from './components/widgets/freedatatimeline/freedata-timeline.widget';
import { FreedataTimelineSettingsPop } from './components/widgets/freedatatimeline/pops/freedata-timeline-settings.pop';
import { FreedataTimelineEditItemRenderer } from './components/widgets/freedatatimeline/renderers/freedatatimeline-edit-item.renderer';
import { FreedataFormWidget } from './components/widgets/freedataform/freedata-form.widget';
import { FreedataFormChoosePop } from './components/widgets/freedataform/renderers/freedata-form-choose.pop';
import { FreeFormWidget } from './components/widgets/freeform/free-form.widget';
import { FreeGridster } from './components/widgets/freeform/freegridster';
import { FreeGridsterItem } from './components/widgets/freeform/freegridster-item';
import { FreeFormSettingsPop } from './components/widgets/freeform/pop/freeform-settings.pop';
import { FreeFormRenderer } from './components/widgets/freeform/renderer/freeform.renderer';
import { WidgetComponent } from './components/widgets/widget.component';
import { WidgetDataPop } from './components/widgets/widgetpops/widget-data.pop';
import { GeneratorDataPop } from './components/widgets/widgetpops/generator-data.pop';
import { WidgetScenarioPop } from './components/widgets/widgetpops/widget-scenario.pop';
import { WidgetDisplaySettingsPop } from './components/widgets/widgetpops/widget-display-settings.pop';
import { WidgetDisplayRightsPop } from './components/widgets/widgetpops/widget-display-rights.pop';
import { WidgetDisplayConnectPop } from './components/widgets/widgetpops/widget-display-connect.pop';
import { ScenAddPop } from './components/widgets/widgetpops/scenadd-pop';
import { ScenPopActionRenderer } from './components/widgets/widgetpops/scen-pop.action.renderer';
import { ScenPopRenderer } from './components/widgets/widgetpops/scen-pop.renderer';
import { MultiDisplayBaseTileRenderer } from './components/multi-display/md-base-tile.renderer';
import { TranslationPop } from './components/translation-pop/translation.pop';
import { LanguageRenderer } from './components/translation-pop/renderers/language.renderer';
import { RoleOrProfileRenderer } from './manager/user/role-or-profile.renderer';
import { RoleAccessRenderer } from './manager/user/role-access.renderer';
import { CustomTooltip } from './manager/user/custom-tooltip';
import { RoleDeleteRenderer } from './manager/user/role-delete-renderer';
import { UserAppRenderer } from './manager/user/user-app.renderer';
import { UserAppLinkRenderer } from './manager/user/user-app-link.renderer';
import { EditUserNameRenderer } from './manager/user/edit-user.renderer';
import { EditUserPasswordRenderer } from './manager/user/edit-password.renderer';
import { AgCodeFlagRenderer } from './framework/components/grid/renderers/ag-code-flag.renderer';
import { CheckFlagLabelRenderer } from './framework/components/grid/renderers/check-flag-label.renderer';

import { GeneratorWidget } from './components/widgets/generator/generator.widget';
import { GeneratorSettingsPop } from './components/widgets/generator/pop/generator-settings.pop';
import { GeneratorRestrictionPop } from './components/widgets/generator/pop/generator-restriction.pop';
import { GeneratorRestrictionRenderer } from './components/widgets/generator/pop/generator-restriction.renderer';
import { ComputePageRenderer } from './components/widgets/pivot/renderers/pagination/compute-page';

import { PolarChartComponent } from './components/ngx-charts/polar-chart/polar-chart.component';
import { PolarSeriesComponent } from './components/ngx-charts/polar-chart/polar-series.component';
import { FormsModule } from '@angular/forms';
import { ZoomPop } from './components/widgets/freedatas/renderers/zoom.pop';
import { SwapPop } from './components/widgets/freedatas/renderers/swap.pop';
import { ThumbRenderer } from './components/widgets/freedatas/renderers/thumb.renderer';
import { PinchZoomModule } from '@mtnair/ngx-pinch-zoom';

@NgModule({
  declarations: [
    CheckFlagLabelRenderer,
    RoleOrProfileRenderer,RoleAccessRenderer, CustomTooltip, AgCodeFlagRenderer,
    RoleDeleteRenderer, UserAppRenderer, UserAppLinkRenderer, EditUserNameRenderer, EditUserPasswordRenderer,
    TranslationPop, LanguageRenderer,
    MultiDisplayBaseTileRenderer,
    WidgetComponent,
    WidgetDataPop, WidgetScenarioPop,
    GeneratorDataPop,
    WidgetDisplaySettingsPop,
    WidgetDisplayRightsPop, WidgetDisplayConnectPop,
    ScenAddPop, ScenPopActionRenderer, ScenPopRenderer,

    FreeFormWidget, FreeGridster, FreeGridsterItem, FreeFormSettingsPop, FreeFormRenderer,
    FreedataCalendarWidget, FreedataCalendarAddPop, FreedataCalendarSettingsPop,
    FreedataTimelineWidget, FreedataTimelineEventRenderer, 
    FreedataTimelineFilterExtendedPop, FreedataTimelineFilterExtendedRenderer,
    FreedataTimelineSettingsPop, FreedataTimelineEditItemRenderer,
    FreedataFormChoosePop, FreedataFormWidget,

    TileWidget, TileSettingsPop, TileGridsterComponent, TileGridsterItem, SmallFormFieldRenderer, TileRenderer,
    FreedataTileWidget, FreedataTileSettingsPop,FreedataTileFilterPop, FreedataTileGridsterComponent, FreedataTileGridsterItem, SmallArgsRenderer, FreedataTileRenderer,

    TimelineWidget, TimelineEventRenderer, TimelineFieldRenderer, TimelineSettingsPop, TimelineEditItemRenderer,  
    CalendarWidget, CalendarAddPop, CalendarEventRenderer, CalendarExtendedPop,

    GlobalFilter, GlobalFilterSettingPop,

    BaselineGridsterItem, BaselineGridsterComponent, FormDropExtendedChronocodePop, FormDropExtendedFreedataPop, 
    FormDropExtendedRenderer, FormExtendedPop, FormFieldRenderer, FormWidget, BaselineFieldSettingsPop, BaselineFormChoosePop,

    FreedataGridWidget, FreedataFormSettingsPop, FreedataGridDeletePop, FreedataGridsterItem, FreedataGridsterComponent,
    FreedataSettingsPop, FreedataWidgetDataPop, FreedataEditItemRenderer, VisionKeyRenderer, ArgsRenderer, ImageSourcePop,

    FreedataFieldSettingsPop,

    ListWidget, ListExtendedPop, ListWidgetItemRenderer,
    ChartWidget, ChartSettingsPop, ChartItemSettingPop, ChartEditItemRenderer, ChartParamRenderer,

    ScenSpotRenderer,
    FreedataHeaderEditPop,
    AddFunctionPop,
    AddMeasurePop,
    FormulaEditorPop,
    FormulaEditorInput,
    AddFunctionRenderer,
    AddMeasureRenderer,
    MeasureKindRenderer,
    ConditionRenderer,
    NextStepPivot, ToolPivot,
    ColorPickerPop,
    ExcelErrorPop,
    ConnectButton, ConnectIconRenderer, ConnectSmallRenderer,
    Pivot, ComputePageRenderer,
    PivotCellEditor, OtherCellEditor,
    PivotBasePop,
    PivotExtendedPop,
    PivotEditItemRenderer, PivotGroupEditItemRenderer,
    PivotDeleteFieldRenderer,
    PivotFilterExtendedRenderer,
    PivotCellEditPop,
    PivotCellFilterkeyEditPop, PivotCellCrosskeyEditPop, PivotCellListEditPop, PivotCellThresholdEditPop, PivotCellWorkflowEditPop, WorkcomMessageRenderer, WorkcomMessagePop,
    PivotCellDeletePop,
    PivotCellMassDeletePop,
    PivotFilterExtendedPop, PivotScenExtendedPop,
    PivotHeaderRenderer, PivotHeaderGroupRenderer,
    HeaderEditExtPop, HeaderGroupEditPop,
    HeaderEditStyleSubPop, PivotIncExcRenderer,
    FilterMassPop, FilterMassRenderer,
    
    CmdErrorPop,
    LoadinPop,
    WidgetRenderer,
    BaseTileRenderer,
    AgActionDeleteRenderer,
    AgLabelValidityRenderer,
    MultiDisplay,
    WizNgxCharts,
    BaseChartComponent,
    CountUpDirective,
    TooltipArea,
    ChartComponent,
    LegendComponent,
    LegendEntryComponent,
    ScaleLegendComponent,
    CircleComponent,
    CircleSeriesComponent,
    GridPanelComponent,
    GridPanelSeriesComponent,
    SvgLinearGradientComponent,
    SvgRadialGradientComponent,
    Timeline,
    AdvancedLegendComponent,
    AxisLabelComponent,
    XAxisComponent,
    XAxisTicksComponent,
    YAxisComponent,
    YAxisTicksComponent,
    TooltipContentComponent,
    TooltipDirective,
    PieLabelComponent,
    PieArcComponent,
    PieChartComponent,
    PieSeriesComponent,
    BarComponent,
    BarHorizontalComponent,
    BarHorizontal2DComponent,
    BarHorizontalStackedComponent,
    BarVerticalComponent,
    BarVertical2DComponent,
    BarVerticalStackedComponent,
    BarLabelComponent,
    SeriesHorizontal,
    SeriesVerticalComponent,
    CardComponent,
    CardSeriesComponent,
    NumberCardComponent,
    TreeMapCellComponent,
    TreeMapCellSeriesComponent,
    TreeMapComponent,
    GaugeComponent,
    GaugeArcComponent,
    GaugeAxisComponent,
    LineChartComponent,
    LineComponent,
    LineSeriesComponent,
    AreaComponent,

    ConnectReturnRenderer,
    ConnectItemRenderer,

    GeneratorWidget, GeneratorSettingsPop, GeneratorRestrictionPop, GeneratorRestrictionRenderer,

    PolarChartComponent, PolarSeriesComponent,
    ZoomPop, SwapPop, ThumbRenderer
  ],
  imports: [
    FormsModule,
    WizModule, WizLayoutModule,
    ColorPickerModule,
    GridsterModule,
    FullCalendarModule,
    PinchZoomModule
    
  ],
  exports: [
    
    CheckFlagLabelRenderer,
    RoleOrProfileRenderer,RoleAccessRenderer, CustomTooltip, AgCodeFlagRenderer,
    RoleDeleteRenderer, UserAppRenderer, UserAppLinkRenderer, EditUserNameRenderer, EditUserPasswordRenderer,
    TranslationPop, LanguageRenderer,
    MultiDisplayBaseTileRenderer,
    WidgetComponent,
    WidgetDataPop, WidgetScenarioPop,
    WidgetDisplaySettingsPop,
    WidgetDisplayRightsPop, WidgetDisplayConnectPop,    
    ScenAddPop, ScenPopActionRenderer, ScenPopRenderer,

    FreeFormWidget, FreeGridster, FreeGridsterItem, FreeFormSettingsPop, FreeFormRenderer,
    FreedataCalendarWidget, FreedataCalendarAddPop, FreedataCalendarSettingsPop,
    FreedataTimelineWidget, FreedataTimelineEventRenderer, 
    FreedataTimelineFilterExtendedPop, FreedataTimelineFilterExtendedRenderer,
    FreedataTimelineSettingsPop, FreedataTimelineEditItemRenderer,
    FreedataFormChoosePop, FreedataFormWidget,

    TileWidget, TileSettingsPop, TileGridsterComponent, TileGridsterItem, SmallFormFieldRenderer, TileRenderer,
    FreedataTileWidget, FreedataTileSettingsPop, FreedataTileGridsterComponent, FreedataTileGridsterItem, SmallArgsRenderer, FreedataTileRenderer,

    TimelineWidget, TimelineEventRenderer, TimelineFieldRenderer, TimelineSettingsPop, TimelineEditItemRenderer,  
    CalendarWidget, CalendarAddPop, CalendarEventRenderer, CalendarExtendedPop,

    GlobalFilter, GlobalFilterSettingPop,

    BaselineGridsterItem, BaselineGridsterComponent, FormDropExtendedChronocodePop, FormDropExtendedFreedataPop, 
    FormDropExtendedRenderer, FormExtendedPop, FormFieldRenderer, FormWidget, BaselineFieldSettingsPop, BaselineFormChoosePop,

    FreedataGridWidget, FreedataFormSettingsPop, FreedataGridDeletePop, FreedataGridsterItem, FreedataGridsterComponent,
    FreedataSettingsPop, FreedataWidgetDataPop, FreedataEditItemRenderer, VisionKeyRenderer, ArgsRenderer,
    
    FreedataFieldSettingsPop,

    ListWidget, ListExtendedPop, ListWidgetItemRenderer,
    ChartWidget, ChartSettingsPop, ChartItemSettingPop, ChartEditItemRenderer, ChartParamRenderer,
    ScenSpotRenderer,
    FreedataHeaderEditPop,
    AddFunctionPop,
    AddMeasurePop,
    FormulaEditorPop,
    FormulaEditorInput,
    AddFunctionRenderer,
    AddMeasureRenderer,
    MeasureKindRenderer,
    ConditionRenderer,
    NextStepPivot, ToolPivot,
    ColorPickerPop,
    ExcelErrorPop,
    ConnectButton, ConnectIconRenderer, ConnectSmallRenderer,
    Pivot, ComputePageRenderer,
    PivotCellEditor,
    PivotBasePop,
    PivotExtendedPop,
    PivotEditItemRenderer, PivotGroupEditItemRenderer,
    PivotDeleteFieldRenderer,
    PivotFilterExtendedRenderer,
    PivotCellEditPop,
    PivotCellFilterkeyEditPop, PivotCellCrosskeyEditPop, PivotCellListEditPop, PivotCellWorkflowEditPop, WorkcomMessageRenderer, WorkcomMessagePop,
    PivotCellDeletePop,
    PivotCellMassDeletePop,
    PivotFilterExtendedPop, PivotScenExtendedPop,
    PivotHeaderRenderer, PivotHeaderGroupRenderer,
    HeaderEditExtPop, HeaderGroupEditPop,
    HeaderEditStyleSubPop, PivotIncExcRenderer,
    FilterMassPop, FilterMassRenderer,

    CmdErrorPop,
    LoadinPop,
    WidgetRenderer,
    BaseTileRenderer,
    AgActionDeleteRenderer,
    AgLabelValidityRenderer,
    MultiDisplay,
    WizNgxCharts,
    BaseChartComponent,
    CountUpDirective,
    TooltipArea,
    ChartComponent,
    LegendComponent,
    LegendEntryComponent,
    ScaleLegendComponent,
    CircleComponent,
    CircleSeriesComponent,
    GridPanelComponent,
    GridPanelSeriesComponent,
    SvgLinearGradientComponent,
    SvgRadialGradientComponent,
    Timeline,
    AdvancedLegendComponent,
    AxisLabelComponent,
    XAxisComponent,
    XAxisTicksComponent,
    YAxisComponent,
    YAxisTicksComponent,
    TooltipContentComponent,
    TooltipDirective,
    PieLabelComponent,
    PieArcComponent,
    PieChartComponent,
    PieSeriesComponent,
    BarComponent,
    BarHorizontalComponent,
    BarHorizontal2DComponent,
    BarHorizontalStackedComponent,
    BarVerticalComponent,
    BarVertical2DComponent,
    BarVerticalStackedComponent,
    BarLabelComponent,
    SeriesHorizontal,
    SeriesVerticalComponent,
    CardComponent,
    CardSeriesComponent,
    NumberCardComponent,
    TreeMapCellComponent,
    TreeMapCellSeriesComponent,
    TreeMapComponent,
    GaugeComponent,
    GaugeArcComponent,
    GaugeAxisComponent,
    LineChartComponent,
    LineComponent,
    LineSeriesComponent,
    AreaComponent,
    ConnectReturnRenderer,
    ConnectItemRenderer,
    ZoomPop
  ]
})

export class CommonModule {
}
